import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ReportDataModal from "../../models/report-data";

export default class ReportDataRepository extends BaseRepository {
  static modelClass = ReportDataModal;
  modelName = "report-data";

  async run(reportId) {
    return await super.findRecord("_", {
      urlPath: `report_data/${reportId}/run/`,
    });
  }
}
